export const ROOM_UUID = "/dde338d2-989f-43ae-8c07-2788f788d433";
export const ROOM_UUID_pr = "443ad998-e3f5-461d-a5ca-e547df773369";
const ROOM_STG = "840019de-152d-4557-9b51-fda5f43629fd";

const stg = "https://servroom.thedigitalhotelier.com/api/guest/v1";
// const stg = "https://staging.thedigitalhotelier.com/api";
const appSgp = "https://dashboard-sgp.thedigitalhotelier.com/api";
const production = "https://dashboard.thedigitalhotelier.com/api";
// const production = "https://dashboard-us.thedigitalhotelier.com/api";

const redirect_production = "https://dashboard.thedigitalhotelier.com";
const redirect_app_sgp = "https://dashboard-sgp.thedigitalhotelier.com";

export const API_URL = process.env.REACT_APP_BASE_API_URL || stg;
export const redirect = process.env.REACT_APP_redirect || redirect_production;

/** Non-guest auth API root — guest verification lives under /api/v1, not /api/guest/v1. */
export const AUTH_API_URL = `${new URL(API_URL).origin}/api/v1`;

export const phoneFormat =
  process.env.REACT_APP_phoneFormat || API_URL.includes("sgp") ? "ph" : "ae";
// https://app-sgp.thedigitalhotelier.com

export const MEDIA_URL =
  process.env.REACT_APP_MEDIA_URL || "https://d3tqyaqcg3i6yj.cloudfront.net";

/** Socket.IO base URL for guest–host chat (override with REACT_APP_CHAT_SOCKET_URL). */
export const CHAT_SOCKET_URL =
  process.env.REACT_APP_CHAT_SOCKET_URL;

/** Optional Socket.IO namespace, e.g. "/chat". Empty = default namespace. */
export const CHAT_SOCKET_NAMESPACE =
  process.env.REACT_APP_CHAT_SOCKET_NAMESPACE || "";

/**
 * Servy's AI service REST API (suggested questions). It runs on the chat
 * socket's host, so it follows REACT_APP_CHAT_SOCKET_URL unless overridden.
 */
export const SERVY_API_URL =
  process.env.REACT_APP_SERVY_API_URL ||
  (CHAT_SOCKET_URL ? `${CHAT_SOCKET_URL.replace(/\/+$/, "")}/v1` : "");

const chatTranslateUrl = process.env.REACT_APP_CHAT_TRANSLATE_URL || "";

/**
 * Guest AI translate endpoint for host–guest chat; the guest id is the bearer
 * token. Staging and production have different URLs (set in .env), and it is
 * off when empty. The endpoint sends no CORS headers yet, so `npm start`
 * calls it same-origin through the dev-server proxy in src/setupProxy.js.
 */
export const CHAT_TRANSLATE_URL =
  process.env.NODE_ENV === "development"
    ? chatTranslateUrl.replace(/^https?:\/\/[^/]+/, "")
    : chatTranslateUrl;
